import { MouseEventHandler } from 'react';

import { Button } from '../Button';
import { Typography } from '../Typography';

import * as S from './Modal.style';

interface IProps {
	children: React.ReactNode;
}

interface IModalProps extends IProps {
	isButton: boolean;
	closeModal: () => void;
}

interface IButtonProps extends IProps {
	onClick?: MouseEventHandler<HTMLButtonElement>;
	disabled: boolean;
}

export function Modal({ children, isButton, closeModal }: IModalProps) {
	return (
		<>
			<S.Container
				onClick={(e) => {
					e.stopPropagation();
					e.preventDefault();
					closeModal();
				}}
			/>
			<S.Modal
				onClick={(e) => {
					e.stopPropagation();
					e.preventDefault();
				}}
				isButton={isButton}
			>
				<S.ModalCloseHeader>
					<S.ModalCloseHeaderBar />
				</S.ModalCloseHeader>
				{children}
			</S.Modal>
		</>
	);
}

export function Header({ children }: IProps) {
	return (
		<S.Header>
			<Typography type="title-large" color="brown-primary">
				{children}
			</Typography>
		</S.Header>
	);
}

export function FixedButton({ children, onClick, disabled }: IButtonProps) {
	return (
		<S.ButtonContainer>
			<Button
				onClick={onClick}
				fullWidth
				bgColor={disabled ? 'warmgray-300' : 'orange-primary'}
				type="button"
				disabled={disabled}
			>
				<Typography type="title-large" color="white-primary">
					{children}
				</Typography>
			</Button>
		</S.ButtonContainer>
	);
}
